import {
  UsageGroupByType,
  UsageType,
} from "@shared/types/localTypes/usage-explorer.ts";
import { GranularityType } from "@shared/types/localTypes/common.ts";
import apiProxy from "@shared/utils/api-proxy.ts";

export interface FetchUsageCsvRequest {
  nonce: string;
  start_date: string;
  end_date: string;
  subscription: number;
  filter_by?: Partial<Record<UsageGroupByType, string[]>>;
  partition_by: GranularityType;
  group_by_keys: UsageGroupByType[];
  partition_group_limit: number;
  expected_total_value: number;
}

export interface FetchUsageCsvResponse {
  nonce: string;
  actual_total_value: number;
  csv_rows: string[];
}

export default async (arg: {
  request: FetchUsageCsvRequest;
  usageType: UsageType;
}) => {
  const { request, usageType } = arg;

  const response: FetchUsageCsvResponse | null = await apiProxy.post(
    `usage-explorer/get-usage-csv/${usageType}`,
    request,
  );

  if (!response) {
    throw new Error("Got no response from server");
  }
  return response;
};
